import axios from "axios";

const base = process.env.REACT_APP_BACKEND_URL || "http://127.0.0.1:8000";

export const api = axios.create({
  baseURL: base + "/api",
  headers: { "Content-Type": "application/json", Accept: "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("usertoken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const urls = {
  login: "/auth/login",
  me: "/auth/me",
  logout: "/auth/logout",
  rdvs: "/rdvs",
  rdvsRecurring: "/rdvs/recurring",
  agents: "/agents",
  clients: "/clients",
  services: "/services",
  dashboard: "/dashboard",
  clientsExport: "/clients/export",
  clientsImport: "/clients/import",
  uiNotifications: "/ui-notifications",
  uiNotifRead: (id) => `/ui-notifications/${id}/read`,

  waStatus: "/whatsapp/status",
  waQr: "/whatsapp/qr",
  waRefresh: "/whatsapp/refresh",
  subscription: "/subscription",
};
